module.exports = __webpack_public_path__ + "static/media/HornBlast.b8a8b604.mp3";